import type { NodeMock, StatePreset } from "../mock-types";

export const gameModeSelectMock: NodeMock = {
  label: "Game Mode Select",
  description: "Players vote on game mode",
  state: (players) => ({
    votes: { [players[0]?.userId ?? ""]: "mode_1" },
    voteCounts: { mode_1: 1, mode_2: 0, mode_3: 0 },
    gameModes: [
      {
        id: "mode_1",
        name: "Competitive",
        description: "Ranked 5v5 with full competitive rules and overtime",
      },
      {
        id: "mode_2",
        name: "Casual",
        description: "Relaxed rules, shorter rounds, no rank impact",
      },
      {
        id: "mode_3",
        name: "Deathmatch",
        description: "Free-for-all elimination, last one standing wins",
      },
    ],
    selectedModeId: null,
  }),
  config: {
    timeoutSeconds: 30,
    selectionMethod: "vote",
    labels: {
      title: "Game Mode",
      subtitle: "Choose your mission type",
    },
  },
};

export const gameModeSelectPresets: StatePreset[] = [
  {
    label: "No Votes",
    build: ({ defaultState }) => ({
      state: { ...defaultState, votes: {}, voteCounts: { mode_1: 0, mode_2: 0, mode_3: 0 } },
    }),
  },
  {
    label: "Heavy Voting",
    build: ({ players, defaultState }) => {
      const votes: Record<string, string> = {};
      const counts: Record<string, number> = { mode_1: 0, mode_2: 0, mode_3: 0 };
      players.forEach((p, i) => {
        const modeId = i % 2 === 0 ? "mode_1" : "mode_2";
        votes[p.userId] = modeId;
        counts[modeId]++;
      });
      return { state: { ...defaultState, votes, voteCounts: counts } };
    },
  },
  {
    label: "Finalized",
    build: ({ players, defaultState }) => {
      const votes: Record<string, string> = {};
      const counts: Record<string, number> = { mode_1: 0, mode_2: 0, mode_3: 0 };
      players.forEach((p) => {
        votes[p.userId] = "mode_1";
        counts.mode_1++;
      });
      return { state: { ...defaultState, votes, voteCounts: counts, selectedModeId: "mode_1" } };
    },
  },
];
